/**
 * Compute the effective total cost of a shipment / pickup:
 *   base `costo` + all enabled extra service costs + urgency surcharge.
 * Keeps the "row cost" fields (admin CostField, edit modal) editing only the
 * base `costo`, but any TOTAL/AGGREGATE view should use this helper so clients
 * that only paid for extras still contribute to the totals.
 */
export function urgencyCost(item) {
  return item?.urgency === "urgente" ? parseFloat(item.urgency_cost) || 0 : 0;
}

export function extrasCost(item) {
  const ex = item?.extra_services || {};
  let total = urgencyCost(item);
  if (ex.sponda) total += parseFloat(ex.sponda_cost) || 0;
  if (ex.camion_completo) total += parseFloat(ex.camion_cost) || 0;
  if (ex.furgone_completo) total += parseFloat(ex.furgone_cost) || 0;
  return total;
}

export function jobTotalCost(item) {
  const base = parseFloat(item?.costo) || 0;
  return base + extrasCost(item);
}

export function hasAnyExtra(item) {
  const ex = item?.extra_services || {};
  return !!(ex.sponda || ex.camion_completo || ex.furgone_completo || urgencyCost(item) > 0);
}
